import React, { useEffect, useState } from 'react';
import M_PEA_BASIC from './M_PEA_BASIC';
import { useDispatch } from 'react-redux';
import { NavBarInfoActions } from '../../../Reducer/NavBarInfoReducer';
import { useSearch1 } from './M_PEA_BASIC_Query';

export default function M_PEA_BASICF() {
  const dispatch = useDispatch();
  const [rowData1, setRowData1] = useState([]);

  useEffect(() => {
    dispatch(NavBarInfoActions.setType('titleBar'));
    dispatch(NavBarInfoActions.setTitleName('나의 결재 대기'));
    dispatch(NavBarInfoActions.setBgColor('#FFF'));
  }, [dispatch]);

  const { refetch: Search1 } = useSearch1({
    onSuccess: (rows) => {
      setRowData1(rows);
    },
  });

  return (
    <div className="h-full">
      <M_PEA_BASIC rowData1={rowData1} SearchLogic1={Search1} />
    </div>
  );
}
